import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export interface IEoDatepickerConfig extends IEoFormControlConfig {
  type?: 'datepicker';
  datePickerStyleClass?: string;
  showIcon?: boolean;
  icon?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showOnFocus?: boolean;
  showClear?: boolean;
  showButtonBar?: boolean;
  formatValueToUtcOnChange?: boolean;
  showTime?: boolean;
  timeOnly?: boolean;
  appendTo?: any;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
}

export class EoDatepickerConfig
  extends EoFormControlConfig
  implements IEoDatepickerConfig
{
  override type?: 'datepicker';
  datePickerStyleClass?: string;
  showIcon?: boolean;
  icon?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showClear?: boolean;
  showOnFocus?: boolean;
  showButtonBar?: boolean;
  showTime?: boolean;
  timeOnly?: boolean;
  formatValueToUtcOnChange?: boolean;
  appendTo?: any;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;

  constructor();
  constructor(obj: IEoDatepickerConfig);
  constructor(obj?: IEoDatepickerConfig) {
    super(obj as IEoFormControlConfig);
    this.type = 'datepicker';
    this.datePickerStyleClass = obj?.datePickerStyleClass;
    this.showIcon = obj?.showIcon;
    this.showTime = obj?.showTime;
    this.timeOnly = obj?.timeOnly;
    this.icon = obj?.icon;
    this.placeholder = obj?.placeholder;
    this.loadingPlaceholder = obj?.loadingPlaceholder;
    this.showOnFocus = obj?.showOnFocus;
    this.showClear = obj?.showClear;
    this.showButtonBar = obj?.showButtonBar;
    this.appendTo = obj?.appendTo;
    this.dateFormat = obj?.dateFormat;
    this.minDate = obj?.minDate;
    this.maxDate = obj?.maxDate;
    this.formatValueToUtcOnChange = obj?.formatValueToUtcOnChange ?? true;
  }
}
